// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CrmControlledReleaseContext from "./CrmControlledReleaseContext.bs.js";

var make = CrmControlledReleaseContext.context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

export {
  make ,
  makeProps ,
  
}
/* make Not a pure module */
